import { List, Stack, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import Impact from '@app/pages/strategies/components/nodes/simulator/impact'
import impactColor from '@app/pages/strategies/components/nodes/simulator/impactColor'
import CardSection from '@app/shared/cards/components/cardSection'
import { useStore } from '@app/store'
import type { CardSize, DomainNode } from '@app/types'
import { formatStat } from '@app/utils/metricHelpers'

type Props = {
  node: Pick<DomainNode, 'data' | 'simPartials1p' | 'simPercentChange'>
  size: CardSize
}

const SimPartialsSection: FC<Props> = ({ node, size }) => {
  const partials = node?.simPartials1p
  const change = node?.simPercentChange || 0
  const getNodeById = useStore.use.getNodeById()
  const calculated = node?.data?.calculated

  const changeSign = change >= 0 ? '+' : ''
  const changeColor = impactColor(change)

  return (
    <CardSection size={size}>
      <Stack>
        <Text lineClamp={1} color={`${changeColor}.700`} bgColor={`${changeColor}.subtle`} fontSize="lg" px={2} py={1}>
          Change {changeSign}
          {formatStat(change, { maximumDisplayPrecision: 2 })}%
        </Text>
        {change !== 0 && !calculated && (partials?.length || 0) > 0 && (
          <List.Root variant="plain" ms="0.75em">
            {partials.map((partial) => {
              const { nodeRfId, deltaR } = partial
              const root = getNodeById(nodeRfId)
              const stat = deltaR * change

              return (
                <List.Item key={partial.nodeId}>
                  <Impact rootNode={root} value={stat} />
                </List.Item>
              )
            })}
          </List.Root>
        )}
      </Stack>
    </CardSection>
  )
}

SimPartialsSection.displayName = 'SimPartialsSection'

export default SimPartialsSection
